export default function CommunicationApi({ makeRequest, buildRequest }) {

	function getTemplates() {
		return buildRequest().then((req) =>
			makeRequest(req.get('/api/Communications/templates'))
		);
	}

	function getTriggerTemplates(triggerId) {
		return buildRequest().then((req) =>
			makeRequest(req.get(`/api/Communications/triggers/${triggerId}/templates`))
		);
	}

	function saveTemplate(payload) {
		return buildRequest().then((req) =>
			makeRequest(req.post('/api/Communications/templates', payload))
		);
	}

	function deleteTemplate(templateId) {
		return buildRequest().then((req) =>
			makeRequest(req.delete(`/api/Communications/templates/${templateId}`))
		);
	}

	function assignTemplates(triggerId, templateIds) {
		return buildRequest().then((req) =>
			makeRequest(req.post('/api/Communications/template-triggers', { triggerId, templateIds }))
		);
	}

	function getAvailableTemplates(code) {
		return buildRequest().then((req) =>
			makeRequest(req.get(`/api/Communications/triggers/${code}/available-templates`))
		);
	}

	function getTriggerFields(code) {
		return buildRequest().then((req) =>
			makeRequest(req.get(`/api/Communications/triggers/${code}/fields`))
		);
	}

	function getEnquiryCommunications(enquiryId) {
		return buildRequest().then((req) =>
			makeRequest(req.get(`/api/Communications/enquiries/${enquiryId}`))
		);
	}

	function sendManualCommunication(payload) {
		return buildRequest().then((req) =>
			makeRequest(req.post('/api/Communications/manual', payload))
		);
	}

	function createInboundManual(payload) {
		return buildRequest().then((req) =>
			makeRequest(req.post('/api/Communications/inbound-manual', payload))
		);
	}

	function getInboundCommunications(enquiryId) {
		return buildRequest().then((req) =>
			makeRequest(req.get(`/api/Communications/${enquiryId}/inbound`))
		);
	}

	function sendCommunicationNow(communicationId) {
		return buildRequest().then((req) =>
			makeRequest(req.post(`/api/Communications/${communicationId}/send-now`))
		);
	}

	function sendTestTemplate(payload) {
		return buildRequest().then((req) =>
			makeRequest(req.post('/api/Communications/templates/test', payload))
		);
	}

	function cancelCommunication(communicationId, reason) {
		return buildRequest().then((req) =>
			makeRequest(req.post(`/api/Communications/${communicationId}/cancel`, reason ? { reason } : undefined))
		);
	}

	function getCommunicationRenderedBody(communicationId) {
		return buildRequest().then((req) =>
			makeRequest(req.get(`/api/Communications/${communicationId}/rendered-body`))
		);
	}

	function getInboundCommunicationContent(communicationInboundId) {
		return buildRequest().then((req) =>
			makeRequest(req.get(`/api/Communications/inbound/${communicationInboundId}/content`))
		);
	}

	function setInboundReadState(communicationInboundId, isRead) {
		return buildRequest().then((req) =>
			makeRequest(req.post(`/api/Communications/inbound/${communicationInboundId}/read-state`, { isRead }))
		);
	}

	return {
		getTemplates,
		deleteTemplate,
		getTriggerTemplates,
		saveTemplate,
		assignTemplates,
		getAvailableTemplates,
		getTriggerFields,
		getEnquiryCommunications,
		sendManualCommunication,
		createInboundManual,
		getInboundCommunications,
		sendCommunicationNow,
		cancelCommunication,
		getCommunicationRenderedBody,
		getInboundCommunicationContent,
		setInboundReadState,
		sendTestTemplate,
	};
}
